import { FC, useMemo } from 'react';
import FilePreviewModal, { type IPreviewItem } from '@srm/ui/file-preview';
import { attachmentPreview, filePreviewSource } from '@services/FilePreviewService';
import { IAttachRow } from './AttachGrid.types';
import { rowFileName } from './attachRowView';

interface AttachPreviewModalProps {
    /** Открытое вложение (null — окно закрыто). */
    row: IAttachRow | null;
    /** Вложения на экране: между ними листают стрелками и переключателем в шапке. */
    rows: IAttachRow[];
    onClose: () => void;
}

const toItem = (row: IAttachRow): IPreviewItem => ({
    key: row.key,
    name: rowFileName(row) || 'Файл',
    origin: attachmentPreview(row.documentKey, row.key),
});

/** Предпросмотр вложения документа. Права проверяет сервер на каждом запросе
 *  (`attachment/view/...` — та же цепочка доступа, что у скачивания). */
const AttachPreviewModal: FC<AttachPreviewModalProps> = ({ row, rows, onClose }) => {
    const items = useMemo(() => {
        if (!row) return [];
        const list = rows.map(toItem);
        // Версию файла открывают из раскрытой строки — её нет среди строк верхнего уровня.
        return list.some((item) => item.key === row.key) ? list : [toItem(row), ...list];
    }, [row, rows]);

    if (!row) return null;

    return <FilePreviewModal items={items} initialKey={row.key} source={filePreviewSource} onClose={onClose} />;
};

export default AttachPreviewModal;
